import gql from 'graphql-tag';
import createCheckoutFragments from '../fragments/create-checkout.fragments';

const CHECKOUT_QUERY = gql`
    query CheckoutExperienceModel {
        checkoutExperienceModel {
            ...CreateCheckoutCheckoutExperienceModel
        }
    }
    ${createCheckoutFragments.CheckoutExperienceModel}
`;

export default CHECKOUT_QUERY;
